// extracted by mini-css-extract-plugin
module.exports = {"ProfileMenu":"style_ProfileMenu__npYSG"};